import { render } from "./settings-index.vue?vue&type=template&id=5d9087e8"
import script from "./settings-index.vue?vue&type=script&lang=js"
export * from "./settings-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__